import styled from 'styled-components';

import { CuiTheme } from '@crehana/ui';

export const BackgroundContainer = styled.div`
  height: 375px;
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
    height: 300px;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    height: 440px;
  }
`;

export const StyledBackground = styled.div`
  width: 100vw;
  position: absolute;
  inset: 0;
  margin: auto;

  background-color: white;
  background-image: radial-gradient(#4b22f4 71%, white 71%);
  background-size: 200px 200px;
  background-repeat: repeat-x;
  background-position: center;

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    background-size: 270px 270px;
  }

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    background-size: 320px 320px;
  }

  ::after {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url('https://crehana-vercel-images-prd.imgix.net/public/2b2a1214-cf95-4159-b9c9-651e3633d914-crehana-fotos-20223722-2-(1).png?auto=format&fit=clip');
    background-size: contain;
    width: 520px;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    background-position: center;

    ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
      width: inherit;
      height: 100%;
    }
  }
`;

export const StyledH2 = styled.h2`
  max-width: 550px;

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    max-width: 700px;
  }
`;
